// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {Href} from 'docs/markdoc/attribute-types';

export const ElementsButtonLink: MarkdocTagRegistration = {
  tag: 'elements-button-link',
  component: 'ElementsButtonLink',
  attributes: {
    label: {
      type: String,
      description: 'The label of the button link',
      localizable: true,
    },
    href: {
      type: Href,
      description: 'The link which opens when this is a link',
    },
  },
};
